import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { eSalaryImage } from '@/common/utils.jsx'
import { TemplateProfileImage } from '@/common/icons.jsx'

const ExternalWorkforceHeader = ({ person, eSalaryCompanyId, submitForm }) => {
  const { t } = useTranslation()

  return (
    <Modal.Header closeButton={!submitForm}>
      {person.otherDetails?.image ? (
        <img src={eSalaryImage(eSalaryCompanyId, person.otherDetails.image)} crossOrigin="anonymous" />
      ) : (
        <TemplateProfileImage />
      )}
      <Modal.Title style={{ width: '100%' }}>
        {person.personId ? person.name : t('AddExternalParty', 'Lisää ulkopuolinen toimija')}
      </Modal.Title>
    </Modal.Header>
  )
}

export default ExternalWorkforceHeader
